import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Top5 from "./pages/Top5";
import AllPicks from "./pages/AllPicks";
import PickDetail from "./pages/PickDetail";
import History from "./pages/History";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import AdminArticles from "./pages/AdminArticles";
import NotFound from "./pages/NotFound";
import ArticlePage from "./pages/ArticlePage";
import AdminUsers from "./pages/AdminUsers";
import Legal from "./pages/Legal";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import ResponsibleGambling from "./pages/legal/ResponsibleGambling";
import BillingTerms from "./pages/legal/BillingTerms";
import RefundPolicy from "./pages/legal/RefundPolicy";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/top-5" element={<ProtectedRoute><Top5 /></ProtectedRoute>} />
            <Route path="/picks" element={<ProtectedRoute><AllPicks /></ProtectedRoute>} />
            <Route path="/picks/:id" element={<ProtectedRoute><PickDetail /></ProtectedRoute>} />
            <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="/admin/articles" element={<ProtectedRoute adminOnly><AdminArticles /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/responsible-gambling" element={<ResponsibleGambling />} />
            <Route path="/billing-terms" element={<BillingTerms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/:sportSlug/:slug" element={<ArticlePage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
